const paths = [
  { label: "Home", labelKey: "navigation.home", path: "/" },
  {
    label: "Package Deals",
    labelKey: "navigation.packageDeals",
    path: "/package-deals",
  },
  {
    label: "Flight Schedules",
    labelKey: "navigation.flightSchedules",
    path: "/flight-schedules",
  },
  { label: "About Us", labelKey: "navigation.aboutUs", path: "/about-us" },
  { label: "Contact Us", labelKey: "navigation.contactUs", path: "/contact-us" },
  { label: "FAQ", labelKey: "navigation.faq", path: "/FAQ" },
  { label: "Jobs", labelKey: "navigation.jobs", path: "/jobs" },
  { label: "Entry Fee", labelKey: "navigation.entryFee", path: "/entry-fee" },
];

export { paths };
